import { isCodeableConceptEqual } from '../unsw-fhir/CodeableConcept';
import { ICondition } from '../unsw-fhir/Condition';
import { IOrganization } from '../unsw-fhir/Organization';
import { IPatient } from '../unsw-fhir/Patient';
import { IQuestionnaire } from '../unsw-fhir/Questionnaire';
import { createQuestionnaireReference } from '../unsw-fhir/Reference';
import { createActivity, generateCarePlan } from './generator';

const SNOMED_CDK_CODING = {
  system: 'http://snomed.info/sct',
  code: '709044004',
  display: 'Chronic kidney disease (disorder)',
};

const SNOMED_DEMENTIA_CODING = {
  system: 'http://snomed.info/sct',
  code: '52448006',
  display: 'Dementia (disorder)',
};

const CDK_CODEABLECONCEPT = { coding: [SNOMED_CDK_CODING] };
const DEMENTIA_CODEABLECONCEPT = { coding: [SNOMED_DEMENTIA_CODING] };
export const getQuestionnaireByCondition = (
  questionnaires: IQuestionnaire[],
  condition: ICondition,
): IQuestionnaire | undefined => {
  if (isCodeableConceptEqual(condition.code, CDK_CODEABLECONCEPT)) {
    return questionnaires.find(questionnaire => questionnaire.name === 'ckd');
  }
  if (isCodeableConceptEqual(condition.code, DEMENTIA_CODEABLECONCEPT)) {
    return questionnaires.find(
      questionnaire => questionnaire.name === 'dementia',
    );
  }
};

export const getConditionByQuestionnaire = (
  questionnaire: IQuestionnaire,
  conditions: ICondition[],
): ICondition | undefined => {
  if (questionnaire.name === 'ckd') {
    return conditions.find(condition =>
      isCodeableConceptEqual(condition.code, CDK_CODEABLECONCEPT),
    );
  }
  if (questionnaire.name === 'dementia') {
    return conditions.find(condition =>
      isCodeableConceptEqual(condition.code, DEMENTIA_CODEABLECONCEPT),
    );
  }
};

export const createEolCarePlan = ({
  patient,
  organization,
  questionnaires,
}: {
  patient: IPatient;
  organization: IOrganization;
  questionnaires: IQuestionnaire[];
}) => {
  const carePlan = generateCarePlan({
    title: 'Eol of Life DST Program',
    patient,
    organization,
  });

  carePlan.activity = [
    createActivity({
      definition: createQuestionnaireReference(
        questionnaires.find(questionnaire => questionnaire.name === 'cristal')!
          .id!,
      ),
    }),
    createActivity({
      definition: createQuestionnaireReference(
        questionnaires.find(
          questionnaire => questionnaire.name === 'patient_values',
        )!.id!,
      ),
    }),
  ];
  return carePlan;
};
